import { render, staticRenderFns } from "./MessageLocation.vue?vue&type=template&id=63986338&"
import script from "./MessageLocation.vue?vue&type=script&lang=js&"
export * from "./MessageLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports